import React, { createContext, useContext } from "react";
import { useAuth } from "@/lib/AuthContext";

// FieldOps role now derives from the host account (server-enforced on every route).
// The old localStorage["fieldops-role"] switcher was a security defect and is gone.
const HOST_TO_FIELD = {
  admin: "Admin",
  account_manager: "Admin",
  pm: "Scheduler",
  estimator: "Scheduler",
  foreman: "Foreman",
  warehouse: "Warehouse",
};

const RoleContext = createContext({ role: "Foreman", setRole: () => {} });

export function RoleProvider({ children }) {
  const { role: hostRole } = useAuth();
  const role = HOST_TO_FIELD[hostRole] || "Foreman";
  if (typeof window !== "undefined") window.__fieldRole = role; // display-only mirror for non-hook helpers
  return <RoleContext.Provider value={{ role, setRole: () => {} }}>{children}</RoleContext.Provider>;
}

export function useRole() {
  return useContext(RoleContext);
}
